import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import { FC } from "react";
import {
  isExcelFileByExtension,
  isWordFileByExtension,
} from "../../../../../../modules/filestore/utils/FileUtil";
import FileViewerExcel from "./components/FileViewerExcel";
import FileViewerWord from "./components/FileViewerWord";

const CLASSNAME = "file-viewer h-[600px] border";

export type FileViewerProps = {
  blob: Blob | undefined;
  fileExtension: string | undefined;
  fileName: string | undefined;
};

const FileViewer: FC<FileViewerProps> = ({ blob, fileExtension, fileName }) => {
  if (!fileExtension || !blob) {
    return <></>;
  }

  const isExcelFile = isExcelFileByExtension(fileExtension);
  const isWordFile = isWordFileByExtension(fileExtension);
  const fileNameHeader = (
    <p className="p-2 fw-bold border-bottom-1">{fileName}</p>
  );

  if (isExcelFile) {
    return (
      <div className={CLASSNAME}>
        {fileNameHeader}
        <FileViewerExcel
          blob={blob}
          fileExtension={fileExtension}
          fileName={fileName}
        />
      </div>
    );
  }

  if (isWordFile) {
    return (
      <div className={CLASSNAME}>
        {fileNameHeader}
        <FileViewerWord
          blob={blob}
          fileExtension={fileExtension}
          fileName={fileName}
        />
      </div>
    );
  }

  const docViewerDocuments = [
    {
      uri: window.URL.createObjectURL(blob),
      fileType: fileExtension,
      fileName,
    },
  ];

  return (
    <div className={CLASSNAME}>
      <DocViewer
        documents={docViewerDocuments}
        pluginRenderers={DocViewerRenderers}
        style={{ height: "100%" }}
      />
    </div>
  );
};

export default FileViewer;
